import React from 'react';
import Hero from '../components/Hero';
import TrustBanner from '../components/TrustBanner';
import Presentation from '../components/Presentation';
import Services from '../components/Services';
import Stats from '../components/Stats';
import About from '../components/About';
import Gallery from '../components/Gallery';
import FAQ from '../components/FAQ';
import BookingForm from '../components/BookingForm';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Toaster } from 'sonner';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <TrustBanner />
      <Presentation />
      <Services />
      <Stats />
      <About />
      <Gallery />
      <FAQ />
      <BookingForm />
      <Footer />
      <WhatsAppButton />
      <Toaster richColors position="top-right" />
    </div>
  );
};

export default Home;
